import { error as svelteError } from '@sveltejs/kit';
import { browser } from '$app/environment';
import { patch_single_product_prices } from '$lib/utils/patch_localized_prices';

/** @type {import('./$types').LayoutLoad} */
export async function load({ params, parent, data, depends }) {
    depends('supabase:auth');

    const { bundles } = await parent();

    let bundle = bundles.find((b) => b.slug === params.bundle);

    if (!params.bundle || !bundle) svelteError(404, 'Bundle not found');

    if (browser) {
        // Patch localized prices
        bundle = /** @type {Bundle} */ (
            await patch_single_product_prices(bundle)
        );
    }

    return {
        ...data,
        bundle
    };
}
